<div class="row">
    <div class="col-3 mb-2" *ngFor="let item of element.Report?.AdditionalInformation?.Commentaries">
        <div class="card text-bg-{{item.PositiveOrNegative === 'Negative' ? 'danger' : item.PositiveOrNegative === 'Positive' ? 'success' : ''}}">
            <div *ngIf="item.Type" class="card-header">{{item.Type}}</div>
            <div *ngIf="item.CommentaryText" class="card-body">
                <p class="card-text">{{item.CommentaryText}}</p>
            </div>
        </div>
    </div>
</div>